import { Component } from '@angular/core';
import { UntypedFormGroup, ReactiveFormsModule } from '@angular/forms';
import { environment } from 'src/environments/environment';
import { ConfigurationFormCoordinatorService } from '../configuration-form-coordinator.service';
import { TranslateModule } from '@ngx-translate/core';
import { YesNoGroupButtonComponent } from '../../../../../base/shared/yes-no-group-button/yes-no-group-button.component';

@Component({
    selector: 'app-configuration-form-lbsftp',
    templateUrl: './configuration-form-lbsftp.component.html',
    styleUrls: ['./configuration-form-lbsftp.component.scss'],
    imports: [ReactiveFormsModule, YesNoGroupButtonComponent, TranslateModule]
})
export class ConfigurationFormLbsftpComponent {

  apiServerUrl = environment.apiServerUrl;
  sftpPort = environment.sftpPort;

  public get configurationFormSFTP(): UntypedFormGroup {
    return this.configurationFormService.configurationFormSFTP;
  }

  constructor(private configurationFormService: ConfigurationFormCoordinatorService) { }
}
